import { Form } from 'react-bootstrap'
import SvgIcon from '../SVG/svg'

type ChangeImageProps = {
	style?: React.CSSProperties
	required?: boolean
}

const ChangeImage = ({style, required = false}: ChangeImageProps) => {
  return (
	<div className='change-image' style={style}>
		<Form.Group className='mb-3'>
			<Form.Control accept='image/*' required={required} id='change-image' type='file' />
			<Form.Label htmlFor='change-image'></Form.Label>
		</Form.Group>
		<SvgIcon type='img-default' />
		<p>Click Here to Change the Image</p>
	</div>
  )
}
export default ChangeImage